import React from 'react'

/**
 * ShadowCatcher — the shared shadow-receiving plane (the receiver half of the
 * old ContactShadow).
 *
 * A large invisible plane at floor level using THREE.ShadowMaterial: fully
 * transparent EXCEPT where a shadow-casting light darkens it, so the splat
 * reads through everywhere except under shadowed geometry. Gaussian splats
 * can't receive shadow maps, so this proxy plane composites the fake shadow
 * over the splat via transparency.
 *
 * ONE plane serves every caster in the scene (the directional sun, the
 * spotlight, …) — ShadowMaterial accumulates all currently-casting lights.
 * Because each light is mounted only while its own toggle is on, a disabled
 * light contributes no shadow here. The `opacity` (scene-level "Shadow"
 * control) sets the darkness of the fake shadow on this plane.
 */
export default function ShadowCatcher({
  floorY = 0.01,
  planeSize = 12,
  opacity = 0.4,
}) {
  return (
    <mesh
      position={[0, floorY, 0]}
      rotation={[-Math.PI / 2, 0, 0]}
      receiveShadow
      // Render after the splat so the transparent shadow composites on top.
      renderOrder={1}
    >
      <planeGeometry args={[planeSize, planeSize]} />
      <shadowMaterial opacity={opacity} transparent depthWrite={false} />
    </mesh>
  )
}
